module.exports = __webpack_public_path__ + "8cb2643b94390b7b41b9a57239e38a0b.fbx";